import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from 'lib/functions/utils';
import { deleteCategory, deleteTag } from 'lib/api/tags';

const DeleteCategory = (props: any) => {
  const { open, onClose, category, setUp } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDeleteCategory = async () => {
    setLoading(true);
    try {
      await deleteCategory(dispatch, category.id);
      showAlert(dispatch, 'success', 'Categoria eliminada correctamente');
      setUp();
      onClose();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al eliminar la categoria');
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Eliminar Categoria</DialogTitle>
        <DialogContent>
          {loading && (
            <div style={{ minHeight: 100 }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          )}
          {!loading && (
            <Typography>¿Estás seguro de querer eliminar la categoria "{category.name}"?</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
            disabled={loading}
          >
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={handleDeleteCategory}
            color="error"
            disabled={loading}
          >
            Eliminar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteCategory;